import React, {Component} from 'react';
import { connect }        from 'react-redux';
import RenderComboCurso   from '../../../container/renderComboCurso';
import {GetRanckingTurmas} from '../../../actions/talentosAction';
import FlashCarregando    from '../../../container/FlashCarregando';
import FlashRetornoNulo   from '../../../container/FlashRetornoNulo';
import {SetError}         from '../../../actions/notificacaoAction';
import { GetListaMenuTopo,
       GetListaSubMenuTopo} from '../../../actions/scopoAction';

class RankingAlunos extends Component {

    constructor(props) {
        super(props);
        this.state = { load1  : false,load2  : false}   
    }

    componentWillMount() {

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:this.props.menu.relatorio.nomeModulo,link:this.props.menu.relatorio.home},
            {action:false,nome:'Ranking de Turmas'}
           ]);
        this.props.GetListaSubMenuTopo([]);
    }

    onChange(e) {
        e.preventDefault();
        if(e.target.value) {
            this.setState({load1: true,load2: false});
            this.props.GetRanckingTurmas(e.target.value).then((response) => {
              this.setState({load2: true});
            }).catch((error) =>{
              this.props.SetError(500);
            });
        }else {
          this.setState({load1: false,load2: false});
        }
    }

    renderListRankingAlunos(){
        const listRankingTurma = this.props.rankingTurma;
        if (listRankingTurma.length) {
            return listRankingTurma.map((elem, i) => {
                return <tr key={i}>
                        <td className="text-center">{elem.tur_nome}</td>
                        <td className="text-center">{elem.total_pontos}</td>
                       </tr>;
            });
        } else {
            return <tr><td colSpan={6} className="text-center"><FlashRetornoNulo/></td></tr>;
        }
    }

    render() {

        return (
            <div>
                <div className="container-bg">               
                    <div className="panel-busca">
                        <form className="form-horizontal">
                            <div className="form-group">
                                <label className="col-sm-2 control-label">Curso</label>
                                <div className="col-sm-5">
                                    <RenderComboCurso funcaoChange={this.onChange.bind(this)}/>
                                </div>
                            </div>
                        </form>
                    </div>
                    {
                        !this.state.load1 ? "" : 
                        !this.state.load2 ? <FlashCarregando/> : <div className="table-responsive">
                        <div className="panel panel-azul-claro panel-cinza">
                            <div className="panel-body table-responsive">
                                <table className="table table_panel">
                                    <thead>
                                        <tr>
                                          <th className="text-center">Turma</th>
                                          <th className="text-center">Total Pontos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      {this.renderListRankingAlunos() }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
             session      : state.auth.session,
             menu         : state.configReducer.menu,
             rankingTurma : state.talentosReducer.allRankingTurma
           }
}

export default connect(mapStateToProps,{GetRanckingTurmas,
                                       SetError,
                                       GetListaMenuTopo,
                                       GetListaSubMenuTopo})(RankingAlunos);


// WEBPACK FOOTER //
// ./src/components/professor/relatorios/ranking_turma.js